export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";

export const SHOW_BACKDROP = "SHOW_BACKDROP";
export const HIDE_BACKDROP = "HIDE_BACKDROP";